export default __webpack_public_path__ + "static/media/pp-img.68eca6ff.webp";